import React from "react";
import MembOtpRegChkApi from "Apis/MembOtpRegChkApi";
import MembAccnDtlInfoInqApi from "Apis/MembAccnDtlInfoInqApi";
import { useEffect, useState } from "react";
import { Navigate, useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import MbpAthnUi from "Utils/MbpAthn";
import { isMobile } from "react-device-detect";
import EmlAthnModalUi from "Utils/EmlAthnModalUi";
import MembOtpRegScrtApi from "Apis/MembOtpRegScrtApi";
import MgpStore from "Stores/Store";
import { Helmet } from "react-helmet-async";
import ApiResultModal from "Components/ApiResultModal";
import { error } from "console";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import refererApi from "Apis/refererApi";


const AppMembPagePasswdChngUi = () => {
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const navigate = useNavigate();
    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    const [membAccnDtlInfo,setMembAccnDtlInfo] = useState<any>();
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");

    const openResultModal = (message: string) => {
        setResultModalMessage(message);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
    };
    
    useEffect(() => {
         refererApi();
    }, [idntMthdCd, navigate]);
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (800/2));
    const [emlAthnPrpsCd] =useState("PWD_RSET_MYPAGE");
    const [showEmlModal, setShowEmlModal] = useState(false);
    const EmlAthnPopFunc = (e:any)=>{
        if (isMobile) {
            setShowEmlModal(true);
        } else {
            window.open(e,"_blank","width=550,height=800 left="+popupX+"top="+popupY);
        }
    }
    const [otpRegYn,setotpRegYn] = useState<any>();
    useEffect(()=>{
        MembAccnDtlInfoInqApi()
        .then((resp) => {
            setMembAccnDtlInfo(resp.apiBody);
        });
        MembOtpRegChkApi()
        .then((resp) => {
            setotpRegYn(resp.apiBody);
        })
        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then((resp) => {
                if(resp.apiHdr.code == "ATHN0000") {
                    MembAccnDtlInfoInqApi()
                    .then((accnResp) => {
                        navigate("/Connect/MyPage/PasswdChngInput", { state: { membAccnDtlInfo: accnResp.apiBody } });
                    });
                }
                if(resp.apiHdr.code == "ATHN2312") {
                    openResultModal(langData&&langData.GLB_ATHN_FAIL_LBL_00);
                }
            });
        }
        window.kmcRespFunc = kmcRespFunc;
        const emlAthnRespFunc =() => {
            MembAccnDtlInfoInqApi()
            .then((accnResp) => {
                navigate("/Connect/MyPage/PasswdChngInput", { state: { membAccnDtlInfo: accnResp.apiBody } });
        });
    }
        window.emlAthnRespFunc = emlAthnRespFunc;
    },[MgpStore.getState().LangSetState.Lang]);
    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
            confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
            app="app"
        />
        <Helmet>
            <title>{`${langData&&langData.MYPAGE_MENU_PASSWD_CHNG_BTN_00}`}</title>
        </Helmet>
        <div className="loginInputWrap">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MENU_PASSWD_CHNG_BTN_00}</p>
            </div>
            <div className="myPageSubCtxtWrap">
                <img className="otpImg" src={process.env.PUBLIC_URL+"/images/Connect/Login/otpAthnIcon.png"} alt="" />
                <div className="otpTxtWrap">
                    <p className="activeText myPageEmlChngActiveText">{langData&&langData.MYPAGE_PASSWD_ATHN_PAGE_TITL_00}</p>
                    <div className="myPageEmlChngMbpAthn loginInputWrap ">
                        {   membAccnDtlInfo&&membAccnDtlInfo.idntMthdCd === "MBP"?
                            <MbpAthnUi  athnPrpsCd='PWD_RSET_MYPAGE'AthnTxt={langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}BtnClass="loginBtn"/>
                            :
                            <>
                            <button onClick={() => EmlAthnPopFunc(`${'/EmlAthnPop?emlAthnPrpsCd=' + emlAthnPrpsCd + "&lang=" +MgpStore.getState().LangSetState.Lang}`)} className="loginBtn">
                                <span>{langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}</span>
                            </button>
                            {showEmlModal && (
                                <EmlAthnModalUi
                                    emlAthnPrpsCd={emlAthnPrpsCd}
                                    onSuccess={(athnPrpsCd: string) => {
                                        setShowEmlModal(false);
                                        if (typeof window.emlAthnRespFunc === 'function') {
                                            window.emlAthnRespFunc(athnPrpsCd);
                                        }
                                    }}
                                    onClose={() => setShowEmlModal(false)}
                                />
                            )}
                            </>
                        }
                    </div>
                </div>
            </div> 
        </div>
        </>
    )
}

export default AppMembPagePasswdChngUi;